module.exports = __webpack_public_path__ + "img/00028.192cde99.webp";